export default __webpack_public_path__ + "static/media/icon-linkedin.c1dc41b4.svg";